import {FixedSizeList as Lists} from 'react-window';
import {
  Box,
  CircularProgress,
  FormControlLabel,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import {
  IParameterDetailsProp,
  CustomDivider,
  IPartnerProps,
} from '../TnnCampaignCreationStepper';
import MusicPreviewBtn from '../../../../components/music/MusicPreviewBtn';
import {IOSSwitch} from '../../../../components/styles/ToggleButton';
import {makeStyles} from '@mui/styles';
import {useCallback, useEffect, useState} from 'react';
import {ICompany} from '../../../../dto/Company.dto';
import useDebounce from '../../../../components/utlis/useDebounce';
import {CustomTextarea} from '../../../../components/styles/CustomTextarea';
import {apiPut} from '../../../../axiosConfig';
import {IApiSuccessMsgResponse} from '../../../../dto/API.dto';
import {AxiosResponse} from 'axios';

export const ReviewCmpt = ({
  campaignName,
  campaignType,
  parameter,
  partners,
  isReview = true,
  notes,
  sponsorRequestId,
  scheduleId,
}: {
  campaignName: string;
  campaignType: string[];
  parameter: IParameterDetailsProp;
  partners: IPartnerProps;
  isReview?: boolean;
  notes?: string;
  sponsorRequestId?: number;
  scheduleId?: number;
}) => {
  return (
    <Box>
      {isReview && (
        <Typography className='font-bold text-16 mb-2'>Review</Typography>
      )}

      <Stack direction={'row'} className='my-2'>
        <Typography className='text-white-50 w-300'>
          Campaign Name/Type
        </Typography>
        <Typography>{`${campaignName} / ${campaignType.join(',')}`}</Typography>
      </Stack>
      <CustomDivider />
      <Box className='my-2'>
        <Typography className='text-white-50 w-300 my-2'>
          {`Campaign Parameter`}
        </Typography>
        <Stack direction={'row'} className='my-2'>
          <Typography className='text-white-50 w-300'>Date</Typography>
          {parameter.start_date && parameter.end_date ? (
            <Typography>{`${parameter.start_date.format(
              'MM-DD-YYYY',
            )} / ${parameter.end_date.format('MM-DD-YYYY')}`}</Typography>
          ) : null}
        </Stack>
        <Stack direction={'row'} className='my-2'>
          <Typography className='text-white-50 w-300'>
            Number Of Runs
          </Typography>
          {parameter.number_of_runs}
        </Stack>
        <Table aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell className='w-160'>Executions/Spots</TableCell>
              <TableCell className='w-160'>Label</TableCell>
              <TableCell className='w-120'>weight</TableCell>
              <TableCell className='w-110'>Primary</TableCell>
              <TableCell>TNN Ad File</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {parameter.slots &&
              parameter.slot_details.map(val => (
                <TableRow key={val.tnn_campaign_slot}>
                  <TableCell align='center'>{val.tnn_campaign_slot}</TableCell>
                  <TableCell>{val?.label ?? ''}</TableCell>
                  <TableCell>{val.tnn_campaign_weightage}</TableCell>
                  <TableCell>
                    <FormControlLabel
                      className='ml-2'
                      label=''
                      control={<IOSSwitch defaultChecked />}
                      checked={Boolean(val.tnn_campaign_is_primary)}
                    />
                  </TableCell>
                  <TableCell>
                    {val.file ? (
                      <Stack direction='row' alignItems='center'>
                        <Typography className='mr-2'>
                          {val.file.name}
                        </Typography>
                        <MusicPreviewBtn
                          id={val.tnn_campaign_slot}
                          url={URL.createObjectURL(val.file)}
                          track_name={val.file.name}
                          track_artist={val.file.name}
                        />
                      </Stack>
                    ) : (
                      <Stack direction='row' alignItems={'center'}>
                        <Typography className='mr-2'>
                          {val.media_track?.file_name ?? val.fileName ?? ''}
                        </Typography>
                        <MusicPreviewBtn
                          id={val.tnn_campaign_slot}
                          url={
                            val.media_track
                              ? val.media_track.url
                              : val.initial_url ?? ''
                          }
                          track_name={
                            val.media_track
                              ? val.media_track.track_name
                              : val.fileName ?? ''
                          }
                          track_artist={
                            val.media_track
                              ? val.media_track.track_artist
                              : val.fileName ?? ''
                          }
                        />
                      </Stack>
                    )}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Box>
      <Box>
        <Stack direction={'row'} spacing={2}>
          {campaignType.includes('GameTime') && (
            <CompanyListCmpt
              title='GameTime Partners'
              companies={partners.gametime.selected_companies}
            />
          )}
          {campaignType.includes('Neptune Radio') && (
            <CompanyListCmpt
              title='Neptune Radio Partners'
              companies={partners.neptuneRadio.selected_companies}
            />
          )}
          {notes !== undefined && sponsorRequestId && scheduleId ? (
            <DebouncedTextField
              notes={notes}
              url={`v1/tnn/sponsor/${sponsorRequestId}/campaign/${scheduleId}/notes`}
            />
          ) : null}
        </Stack>
      </Box>
    </Box>
  );
};

const useListStyles = makeStyles({
  listContainer: {
    width: '300px',
    height: '275px',
    overflow: 'auto',
    backgroundColor: '#1a1a1a',
    padding: '16px',
    borderRadius: '8px',
    color: 'white',
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    backgroundColor: '#000000',
    zIndex: 1,
    padding: '8px 15px',
  },
  listItemButton: {
    padding: '0',
    backgroundColor: '#3B7ABC !important',
    marginBottom: '8px',
    '&:hover': {
      backgroundColor: '#1E5562 !important',
      border: 'none !important',
    },
    border: 'none !important',
    borderRadius: '3px !important',
    height: '40px',
    margin: '10px 0px !important',
  },
  activeListItemButton: {
    backgroundColor: '#1E5562 !important',
  },
  listItemText: {
    color: 'white',
    textAlign: 'center',
  },
  scrollbar: {
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#007BFF',
    },
  },
});

export const CompanyListCmpt = ({
  title,
  companies,
}: {
  title: string;
  companies: ICompany[];
}) => {
  const classes = useListStyles();

  const Row = useCallback(
    ({index, style}: {index: number; style: React.CSSProperties}) => {
      const value = companies[index] as ICompany;

      return (
        <Box style={{...style, padding: '0px 6px 6px 6px'}}>
          {/* Apply padding to the container */}
          <ListItemButton
            key={value.id}
            divider
            className={classes.listItemButton}
            dense>
            <ListItem>
              <ListItemText
                primary={value.name}
                classes={{primary: classes.listItemText}}
              />
            </ListItem>
          </ListItemButton>
        </Box>
      );
    },
    [classes.listItemButton, classes.listItemText, companies],
  );

  return (
    <Box className='w-330'>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        alignContent={'center'}
        className={classes.stickyHeader}>
        <Typography variant='h6' className='mt-2'>
          {`${title} ( ${companies ? companies.length : 0} )`}
        </Typography>
      </Stack>
      <Lists
        className={`${classes.listContainer} ${classes.scrollbar} w-330 h-330 overflow-auto scrollbar bg-dark border-radius-0`}
        height={560}
        itemCount={companies.length}
        itemSize={44}
        width='100%'>
        {Row}
      </Lists>
    </Box>
  );
};

export const DebouncedTextField = ({
  notes,
  url,
}: {
  notes: string;
  url: string;
}) => {
  const [newNotes, setNewNotes] = useState(notes);
  const [isLoading, setIsLoading] = useState(false);

  const debouncedText = useDebounce(newNotes, 1000);

  const handleSubmit = useCallback(() => {
    apiPut(url, {
      notes: debouncedText,
    })
      .then((_response: AxiosResponse<IApiSuccessMsgResponse>) => {
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error submitting notes:', error);
        setIsLoading(false);
      });
  }, [url, debouncedText]);

  useEffect(() => {
    if (debouncedText === notes) return;
    const runApi = async () => {
      setIsLoading(true);
      await handleSubmit();
    };

    runApi();
  }, [debouncedText, handleSubmit, notes]);

  const handleChange = useCallback(e => {
    setNewNotes(e.target.value);
  }, []);

  return (
    <Box position='relative' width='360px' height='375px'>
      <CustomTextarea
        id='message-description'
        placeholder='Enter Note here'
        onChange={handleChange}
        value={newNotes}
        sx={{
          height: '100%',
          m: 0,
          p: 0,
          '& .MuiInputBase-root': {
            height: '100%',
            alignItems: 'stretch',
            backgroundColor: 'transparent',
          },
        }}
      />
      {isLoading && (
        <Box
          position='absolute'
          bottom={8}
          right={8}
          display='flex'
          alignItems='center'
          justifyContent='center'>
          <CircularProgress size={20} />
        </Box>
      )}
    </Box>
  );
};
